<script>
import { format, subDays, addDays, isEqual, isSameMonth, startOfMonth, endOfMonth } from 'date-fns';

export default {
	props: {
		default_label: {
			type: String,
			required: false
		},
		value: {
			type: Object,
			required: false
		},
		compact: {
			type: Boolean,
			required: false,
			default: true
		},
		noFutureValues: {
			type: Boolean,
			required: false,
			default: false
		}
	},
	methods: {
		click_1dan: function (evt) {
			this.custom_set = true;
			this.title = 'Danes';
			let start = new Date();
			this.izbranDatum = { start: start, end: start };
		},
		click_prev7dni: function (evt) {
			this.custom_set = true;
			this.title = '-7 dni';
			let end = new Date();
			let start = subDays(end, 7);
			this.izbranDatum = { start: start, end: end };
		},
		click_prev30dni: function (evt) {
			this.custom_set = true;
			this.title = '-30 dni';
			let end = new Date();
			let start = subDays(end, 30);
			this.izbranDatum = { start: start, end: end };
		},
		click_next7dni: function (evt) {
			this.custom_set = true;
			this.title = '+7 dni';
			let start = new Date();
			let end = addDays(start, 7);
			this.izbranDatum = { start: start, end: end };
		},
		click_next30dni: function (evt) {
			this.custom_set = true;
			this.title = '+30 dni';
			let start = new Date();
			let end = addDays(start, 30);
			this.izbranDatum = { start: start, end: end };
		},
		click_taMesec: function (evt) {
			this.custom_set = true;
			this.title = 'Ta mesec';
			let start = startOfMonth(new Date());
			let end = endOfMonth(start);
			this.izbranDatum = { start: start, end: end };
		},
		click_prev3mesece: function (evt) {
			this.custom_set = true;
			this.title = '-3 mesece';
			let end = new Date();
			let start = subDays(end, 90);
			this.izbranDatum = { start: start, end: end };
		},
		click_prev6mesecev: function (evt) {
			this.custom_set = true;
			this.title = '-6 mesecev';
			let end = new Date();
			let start = subDays(end, 180);
			this.izbranDatum = { start: start, end: end };
		},
		click_pocisti: function () {
			this.clear();
			this.$refs.dropdown.hide();
		},
		selected: function (env) {
			if (!this.izbranDatum || !this.izbranDatum.start || !this.izbranDatum.end) {
				this.$emit('input', this.izbranDatum);
				return;
			}
			if (!this.custom_set) {
				if (isEqual(this.izbranDatum.start, this.izbranDatum.end)) {
					// en dan
					this.is_smalltext_class = false;
					this.title = format(this.izbranDatum.start, 'DD.MM.YYYY');
				} else if (isSameMonth(this.izbranDatum.start, this.izbranDatum.end)) {
					// znotraj meseca
					this.is_smalltext_class = true;
					this.title = format(this.izbranDatum.start, 'DD') + '.-' + format(this.izbranDatum.end, 'DD.MM') + '.';
				} else {
					// custom
					this.is_smalltext_class = true;
					this.title = format(this.izbranDatum.start, 'DD.MM') + '.-' + format(this.izbranDatum.end, 'DD.MM') + '.';
				}
			} else {
				this.is_smalltext_class = false;
			}
			this.custom_set = false;
			this.$emit('input', this.izbranDatum);
			this.$refs.dropdown.hide();
		},
		clear: function () {
			this.is_smalltext_class = false;
			this.custom_set = false;
			this.title = null;
			this.izbranDatum = null;
		}
	},
	computed: {
		selectedTitle () {
			if (this.title) {
				return this.title;
			} else if (this.default_label) {
				return this.default_label;
			} else {
				return this.default_label_empty;
			}
		},
		showCompact () {
			if (this.compact != null) {
				return this.compact;
			} else {
				return true;
			}
		}
	},
	data: function () {
		return {
			is_smalltext_class: false,
			custom_set: false,
			title: null,
			izbranDatum: null,
			default_label_empty: 'Vse'
		}
	},
	created () {
	}
}
</script>
<template>
	<b-dropdown :text="selectedTitle" ref="dropdown" :class="{ smalldt: (is_smalltext_class && showCompact) }">
		<b-dropdown-form class="date-dd">
			<b-row>
				<b-col sm="8" class="p-0">
					<v-date-picker v-model="izbranDatum" is-inline :max-date="noFutureValues ? new Date() : null" is-expanded mode="range" locale="sl-SI" @input="selected" />
					<b-button size="sm" @click.prevent="click_pocisti">Odstrani</b-button>
				</b-col>
				<b-col sm="4" class="tools">
					<b-list-group>
						<b-list-group-item href="#zadnjiMesec" @click.prevent="click_prev30dni">Zadnjih 30 dni</b-list-group-item>
						<b-list-group-item href="#zadnjiTeden" @click.prevent="click_prev7dni">Zadnjih 7 dni</b-list-group-item>
						<b-list-group-item href="#danes" @click.prevent="click_1dan">Danes</b-list-group-item>
						<b-list-group-item v-if="noFutureValues == false" href="#naslednjiTeden" @click.prevent="click_next7dni">Naslednjih 7 dni</b-list-group-item>
						<b-list-group-item v-else href="#zadnje 3 mesece" @click.prevent="click_prev3mesece">Zadnje 3 mesece</b-list-group-item>
						<b-list-group-item v-if="noFutureValues == false" href="#naslednjiMesec" @click.prevent="click_next30dni">Naslednjih 30 dni</b-list-group-item>
						<b-list-group-item v-else href="#zadnjih 6 mesece" @click.prevent="click_prev6mesecev">Zadnjih 6 mesecev</b-list-group-item>
						<b-list-group-item href="#taMesec" @click.prevent="click_taMesec">Ta mesec</b-list-group-item>
					</b-list-group>
				</b-col>
			</b-row>
		</b-dropdown-form>
	</b-dropdown>
</template>
<style scoped>
.date-dd {
	width: 34rem!important;
}
.vc-border {
	border-width: 0!important;
}
.tools {
	padding-top: 12px;
	padding-left: 10px;
	padding-right: 8px;
	padding-bottom: 12px;
}
.smalldt button.btn {
	font-size: 0.6rem;
}
</style>


// WEBPACK FOOTER //
// src/components/DatumFilterDropdown.vue